import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog.tsx";
import { mcpOAuthDialogContent, type McpOAuthFailure } from "@/shared/connectors/mcpOAuthErrors.ts";

export const McpOAuthErrorDialog = ({
  failure,
  onClose,
}: {
  failure: McpOAuthFailure | null;
  onClose: () => void;
}) => {
  const content = failure ? mcpOAuthDialogContent(failure) : null;

  return (
    <AlertDialog open={content !== null} onOpenChange={(open) => !open && onClose()}>
      {content && (
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{content.title}</AlertDialogTitle>
            <AlertDialogDescription>{content.description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction>Close</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      )}
    </AlertDialog>
  );
};
